import styled from '@emotion/styled'
import {
  AccountSelectionBuilder,
  FieldMappingBuilder,
  IntegrationFormField,
  IntegrationFormManager,
  IntegrationNameBuilder,
} from './components'

const FullWidth = styled.div`
  width: 100%;
`

export const Branch = ({ assignment }) => {
  const integrationNameField = new IntegrationNameBuilder().build()
  const accountSelectionField = new AccountSelectionBuilder().resetOnChange(true).build()
  const fieldMapping = new FieldMappingBuilder()
    .placement(2)
    .integrationTitle('Branch')
    .mappingType('supplemental')
    .build()

  const BranchFormFields: IntegrationFormField[] = [
    integrationNameField,
    accountSelectionField,
    fieldMapping,
  ]

  return (
    <FullWidth>
      <IntegrationFormManager
        integrationType="branch"
        integrationAssignment={assignment}
        integrationFields={BranchFormFields}
      />
    </FullWidth>
  )
}
